<template>
<v-container fluid pa-0 class="rounded-tl-md rounded-tr-md table-container d-flex flex-column flex-grow-1 full-height ">

	<!-- fake header -->
	<bee-table-header v-if="!innerRendered" :headers="headers"></bee-table-header>
	<v-row v-if="!innerRendered"  align="center" justify="center">
		<v-progress-circular 
			:size="50" class="pa-5 ma-5 loading-iter primary--text"
			indeterminate></v-progress-circular>
	</v-row>

    <v-data-iterator 
		class="d-flex flex-column fixed-header"
		:style="[maxHeight ? {'max-height': maxHeight }  : {'max-height': '55vh'}]"
		:items="items"
		:items-per-page.sync="itemsPerPage"
		:page="page"
		:search="search"
		:sort-by="sortBy.toLowerCase()"
		:sort-desc="sortDesc"
		:hide-default-footer="hideDefaultFooter">
		<template v-slot:header  v-if="innerRendered">
			<bee-table-header :headers="headers" id="header"></bee-table-header>
		</template>
		<template v-slot:default="props">
		<v-row style=" overflow-y: auto !important; max-height: 80%;" class="mb-0 px-3 py-0"  v-show="innerRendered" id="table-rows">
			<v-col v-for="(row, index) in props.items" :key="row.name" cols="12" class="py-0 flex-shrink">
				<v-form v-model="valids[`valid_${index}`]" :class="passhighlightedExpression(row) ?  highlightedColor : (index%2 == 0 && !!zebra ) ? 'zebra' : ''" class="flex d-flex">
					<!--force render slot before parent  by  slot-scope="{}"  HACK WAY-->
					<bee-table-row  @appear="handleAppear" slot-scope="" :item="row" :headers="headers" :editable="editableRowIndex == index"
						@contextmenu="(e, i) => $emit('contextmenu', e, i)">
						<template v-for="header in headers" v-slot:[`item.${headers.indexOf(header)}`]="{ item }">
							<slot :name="`item.${headers.indexOf(header)}`" :item="item"></slot>
						</template>
					</bee-table-row>
				</v-form>
			</v-col>
		</v-row>
		<v-row v-if="addable" class="my-0 px-3">
			<v-col cols="12" class="py-0">
				<v-form v-model="valids[`valid_end`]" class="flex d-flex">
					<bee-table-row :headers="headers" :add-row="true">
					<template v-for="header in headers" v-slot:[`item.${headers.indexOf(header)}`]>
						<slot :name="`footer.${headers.indexOf(header)}`"></slot>
					</template>
					</bee-table-row>
				</v-form>
			</v-col>
		</v-row>
		</template>
		<template v-slot:no-data>
			<input type="hidden" :id="nodata">
			<v-row v-if="addable" class="my-0 px-3" :class="!innerRendered ? '' : 'last-row'">	
				<v-col cols="12" class="py-0">
					<v-form v-model="valids[`valid_end`]" class="flex d-flex">
					<bee-table-row :headers="headers" :add-row="true">
						<template v-for="header in headers" v-slot:[`item.${headers.indexOf(header)}`]>
						<slot :name="`footer.${headers.indexOf(header)}`"></slot>
						</template>
					</bee-table-row>
					</v-form>
				</v-col>
			</v-row>
			<v-row v-else class="last-row px-3" style="text-align: center !important;"><v-col cols="12" lg="12" style="color: rgba(0, 0, 0, 0.38); font-size: 0.875rem !important" class="d-flex justify-center" >
				{{$t('no-data')}}
			</v-col></v-row>
		</template>
    </v-data-iterator>
</v-container>
</template>

<script>
const loadStatus={
	init:0, //create	
	mounted:1,
	appear:2,
};
/* eslint-disable */

function createGuid()  
{  
   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {  
      var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);  
      return v.toString(16);  
   });  
}  

export default {
	data: () => ({
		search: '',
		sortDesc: false,
		page: 1,
		sortBy: 'name',
		valids: {},
		innerAppear:0,
		loadStatus:loadStatus.init,
		innerRendered:false,
		nodata:createGuid()
	}),
	computed:{
		showinnerSpinner()
		{
			return this.loadStatus!=loadStatus.appear ;//  this.loadStatus!=loadStatus.appear;
		},
		hasFooterSlot() {
  			return !!this.$slots['no-data']
		}
	},
	watch:{
		innerAppear(){
			if((this.loadStatus==loadStatus.mounted && this.innerAppear>=this.items.length)){
				// this.$nextTick(() => {
				// this.loadStatus=loadStatus.appear;
				// });
				this.loadStatus=loadStatus.appear;
				this.innerRendered=true;
				//on inner render done  -- useful to handle data iter comp 
				this.$emit("innerRendered");
			}
		},
	},
	methods:{
		handleAppear(){
			this.innerAppear++;
		},
		
		openLoading(){
			if(this.loadStatus=loadStatus.appear)
			this.innerRendered=false;
		},
		closeLoading(){
			if(this.loadStatus=loadStatus.appear)
			this.innerRendered=true;
		},
		passhighlightedExpression(item)
		{
			let result =this.highlightedExpression ? this.highlightedExpression(item) : false;
			return result;
		}
	},
	mounted(){
		this.loadStatus=loadStatus.mounted;
		setTimeout(()=> {
			this.$nextTick(() => {
			if(document.getElementById(this.nodata))
			{
				if(this.innerAppear==0)
				{
					this.innerRendered=true;
					this.loadStatus=loadStatus.appear;
					this.$emit("innerRendered");
				}
			 }
     	 });
		}, 2000);

	},
	props: [
		'addable', 'headers', 'items', 'hideDefaultFooter', 'itemsPerPage', 'itemClass', 'editableRowIndex', 'zebra','highlighted-color','highlighted-expression', 'max-height',
	],

	i18n:{
		messages: {
			ar: {
				'no-data': '.لا تتوفر بيانات'
			},
			en: {
				'no-data': 'No data.'
			},
			es: {
				'no-data': 'Sin datos.'
			},
		}
	}
}
/* eslint-disable */
</script>
<style scoped>
.zebra {
   background-color: rgba(0, 0, 0, .05);
}
.zero {
    background: rgb(102, 222, 78) !important;
}
.fixed-header div#table-rows{
	margin-top: 50px;
}
.fixed-header .last-row{
	margin-top: 50px !important;
}
.fixed-header .header{
	position: fixed;
	left: 12px;
	right: 12px;
	top: auto;
	z-index: 1;
	padding-left: 12px !important;
	padding-right: 12px !important;
}
</style>
<style>
.loading-iter svg {
    -webkit-animation: progress-circular-rotate 0.8s ease-in-out infinite !important;
    animation: progress-circular-rotate 0.8s ease-in-out infinite  !important;
    transform-origin: center center !important;
    transition: all 0.2s ease-in-out !important;
}
.table-container {
	height: calc(100vh - calc(100vh - 100%));
	border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}
[dir="rtl"] div#table-rows .tr.text-center .td:not(:last-child) {
    border-left: 1px solid #dddddd;
}
[dir="rtl"] div#table-rows .tr.text-center .td:nth-last-child(2) {
    border-left: 1px solid transparent;
}
[dir="ltr"] div#table-rows .tr.text-center .td:not(:first-child) {
    border-left: 1px solid #dddddd;
}
[dir="ltr"] div#table-rows .tr.text-center .td:nth-last-child(1) {
    border-left: 1px solid transparent;
}
</style>